import { FC } from 'react';

import { KEY_BLOBS } from './constants';
import { KeyComponentProps, KeyConfiguration, OnKeyPlayedFn } from './types';

export type KeyboardProps = {
  /** Renders one key. The app passes `KeyWrapper`, which owns the sound and ripple hooks. */
  keyComponent: FC<KeyComponentProps>;
  keys?: KeyConfiguration[];
  onKeyPlayed?: OnKeyPlayedFn;
};

export type KeyboardWrapperProps = Omit<KeyboardProps, 'keyComponent'>;

export function Keyboard({ keyComponent: KeyComponent, onKeyPlayed, keys = KEY_BLOBS }: KeyboardProps) {
  return (
    <div className='flex flex-no-wrap max-w-full max-h-full h-full w-full items-center justify-center gap-0 flex-col sm:flex-row self-center'>
      {keys.map((keyBlob) => (
        <KeyComponent key={keyBlob.letter} {...keyBlob} onKeyPlayed={onKeyPlayed} />
      ))}
    </div>
  );
}
